import axios from "axios";
import { configState } from "./State";

const get_login = async () => {
  const cid = localStorage.getItem("cid");
  const token = localStorage.getItem("token");
  let result = await axios.post(configState.api + "/gympass_admin/get_login", {
    cid: cid,
    token: token,
  });
  return result;
};

export default get_login;

// 50 강사회원
// 100 점상
// 500 최고관리자